/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UserFollowingIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'User Following',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m15,10.49998c-2.48535,0-4.5,2.01465-4.5,4.5s2.01465,4.5,4.5,4.5,4.5-2.01465,4.5-4.5-2.01465-4.5-4.5-4.5Zm2.39941,3.3501l-2.30908,3.1499c-.11084.15186-.28467.24512-.47266.25439-.01025.00049-.021.00098-.03125.00098-.17676,0-.3457-.07471-.46484-.20703l-1.43848-1.59912c-.23047-.25684-.20996-.65186.04688-.88281.25586-.23096.65088-.21045.88281.04688l.92432,1.02734,1.85449-2.52979c.2041-.27832.59619-.33887.87354-.13428.27832.2041.33838.59521.13428.87354Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m2.27441,18.75194c-.05273,0-.10645-.00537-.16016-.01709-.40479-.08838-.66162-.48828-.57324-.89258.5957-2.73096,3.31348-5.02539,6.6084-5.58008.40625-.06543.79492.20654.86426.61523.06885.40869-.20703.79541-.61523.86426-2.70605.45557-4.92334,2.27295-5.3916,4.41992-.07666.35107-.38721.59033-.73242.59033Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m10,10.85204c-2.48535,0-4.50732-2.15332-4.50732-4.80029,0-2.64648,2.02197-4.7998,4.50732-4.7998s4.50732,2.15332,4.50732,4.7998c0,2.64697-2.02197,4.80029-4.50732,4.80029Zm0-8.1001c-1.6582,0-3.00732,1.48047-3.00732,3.2998,0,1.81982,1.34912,3.30029,3.00732,3.30029s3.00732-1.48047,3.00732-3.30029c0-1.81934-1.34912-3.2998-3.00732-3.2998Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
